import { Calendar, MapPin, Clock, User, Users, Star, ExternalLink, Wifi } from "lucide-react";

const MetaRow = ({ icon: Icon, children }) => (
  <div className="flex items-start gap-2 text-sm text-slate-500 mb-1.5">
    <Icon className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" />
    <span className="leading-snug">{children}</span>
  </div>
);

export const EducationCard = ({ edu, isFav, onToggleFav }) => {
  const isFull = edu.seats_total != null && edu.seats_taken >= edu.seats_total;
  return (
    <article
      data-testid={`education-card-${edu.id}`}
      className="group relative flex flex-col bg-white rounded-2xl border border-slate-200 p-6 transition-all duration-200 hover:border-blue-300 hover:shadow-md"
    >
      <div className="flex flex-wrap gap-2 mb-3">
        <span
          data-testid="card-mode-badge"
          className={`px-2.5 py-1 rounded-md text-xs font-semibold uppercase tracking-wide inline-flex items-center gap-1 ${
            edu.mode === "Online" ? "bg-emerald-50 text-emerald-700" : "bg-blue-50 text-blue-700"
          }`}
        >
          {edu.mode === "Online" && <Wifi className="w-3 h-3" />}
          {edu.mode}
        </span>
        {(edu.subjects || []).slice(0, 2).map((s) => (
          <span key={s} className="px-2.5 py-1 rounded-md text-xs font-semibold bg-slate-100 text-slate-600 uppercase tracking-wide">
            {s}
          </span>
        ))}
        <span
          className={`px-2.5 py-1 rounded-md text-xs font-semibold uppercase tracking-wide ${
            edu.price === "Plaćeno" ? "bg-rose-50 text-rose-700" : "bg-amber-50 text-amber-700"
          }`}
        >
          {edu.price}
        </span>
        <span data-testid="card-source-badge" className="px-2.5 py-1 rounded-md text-xs font-semibold bg-indigo-50 text-indigo-700 uppercase tracking-wide">
          {edu.source}
        </span>
      </div>

      <h3 data-testid="card-title" className="font-heading text-lg font-semibold text-slate-900 mb-3 leading-snug line-clamp-3">
        {edu.title}
      </h3>

      <div className="mb-1">
        <MetaRow icon={Calendar}>{edu.start_display}</MetaRow>
        <MetaRow icon={MapPin}>
          {edu.location}
          {edu.county ? ` · ${edu.county} županija` : ""}
        </MetaRow>
        {edu.deadline_display && <MetaRow icon={Clock}>Prijave do {edu.deadline_display}</MetaRow>}
        {edu.leader && <MetaRow icon={User}>{edu.leader}</MetaRow>}
        {edu.seats_total != null && (
          <MetaRow icon={Users}>
            <span className={isFull ? "text-red-600 font-medium" : ""}>
              {edu.seats_taken}/{edu.seats_total} prijavljenih{isFull ? " · Popunjeno" : ""}
            </span>
          </MetaRow>
        )}
        {edu.seats_free != null && (
          <MetaRow icon={Users}>
            <span className={edu.seats_free === 0 ? "text-red-600 font-medium" : ""}>
              {edu.seats_free === 0 ? "Popunjeno" : `Slobodnih mjesta: ${edu.seats_free}`}
            </span>
          </MetaRow>
        )}
      </div>

      <div className="mt-auto pt-5 flex items-center justify-between border-t border-slate-100">
        <button
          data-testid="card-favorite-btn"
          onClick={() => onToggleFav(edu.id)}
          aria-label={isFav ? "Ukloni iz spremljenih" : "Spremi edukaciju"}
          className={`p-2 -ml-2 rounded-full hover:bg-slate-100 transition-colors ${
            isFav ? "text-yellow-500" : "text-slate-400 hover:text-yellow-500"
          }`}
        >
          <Star className={`w-5 h-5 ${isFav ? "fill-yellow-400 text-yellow-500" : ""}`} />
        </button>
        <a
          data-testid="card-apply-btn"
          href={edu.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 justify-center px-5 py-2 text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-sm"
        >
          Prijava
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </article>
  );
};
